/*  ========================================================================
    # Scripts - Accordion
    ========================================================================  */

/**
 * Script to handle the accordion section functionality
 */

const Accordion = {
  cfg: {
    containers: document.querySelectorAll('.s-accordion')
  },

  initializeAccordion() {
    this.cfg.containers.forEach(container => {
      const toggles = container.querySelectorAll('.s-accordion__toggle');
      toggles.forEach(toggle => {
        toggle.addEventListener('click', () => {
          const willBeExpanded = toggle.getAttribute('aria-expanded') !== 'true';
          toggle.setAttribute('aria-expanded', `${willBeExpanded}`);
          const panel = document.getElementById(toggle.getAttribute('aria-controls'));
          panel.setAttribute('aria-hidden', `${!willBeExpanded}`);
          panel.toggleAttribute('inert', !willBeExpanded); // Prevent children from receiving keyboard focus
        });
      });
    });
  },

  /**
   * Initialize.
   */
  init() {
    if (this.cfg.containers) {
      this.initializeAccordion();
    }
  }
};

export default Accordion;
